import React from "react"
import styled from "styled-components"
import Content from "components/Content"
import Container from "components/Container"
import Section from "components/Section"
import NewsletterSignup from "components/NewsletterSignup"

const StyledSection = styled(Section)`
  h2 {
    text-transform: uppercase;
    color: ${(props) => props.theme.colors.kelp};

    + p {
      font-size: 1.8rem;
      color: ${(props) => props.theme.colors.kelp};
    }
  }

  ${(props) => props.theme.media.tablet_landscape_up`
    text-align: center;
  `}
`

const StyledContainer = styled(Container)`
  ${(props) => props.theme.media.tablet_landscape_up`
    max-width: 60rem;
  `}
`

function Newsletter({ content, ...props }) {
  const { newsletter_title, newsletter_content, legal, ...rest } = content
  return (
    <StyledSection>
      <StyledContainer>
        <Content content={newsletter_title} />
        <Content content={newsletter_content} />
      </StyledContainer>
      <NewsletterSignup legal={legal} {...rest} {...props} />
    </StyledSection>
  )
}

export default Newsletter
